// @ts-expect-error -- webpack resolves asset imports at build-time

export const introShellCss = "ivxq7ds";
export const introShellPhoneCss = "iulcs9l";
export const heroPanelCss = "h1yb9umt";
export const introContentCss = "i1cdgwo0";
export const introContentPhoneCss = "iggzexa";
export const introHeaderPhoneCss = "i1jzf6b8";
export const featureListCss = "f13yztx4";
export const featureItemCss = "fehx84t";
export const featureIconCss = "f1jpyh83";
export const bodyStackCss = "b1p3mg1h";
export const footerPhoneCss = "fwpw2ss";
export const learnMoreLinkCss = "ly85fri";

require("./brandRefreshIntroModalStyles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./brandRefreshIntroModalStyles.ts");